import React, { useState, useEffect } from 'react'

const normBearing = b => Math.round(((b % 360) + 360) % 360)

const MapControls3D = ({ map, exaggeration, setExaggeration, getPitchLimit }) => {
  const [zoom,    setZoom]    = useState(Math.round(map.getZoom()))
  const [pitch,   setPitch]   = useState(Math.round(map.getPitch()))
  const [bearing, setBearing] = useState(normBearing(map.getBearing()))

  useEffect(() => {
    const onZoom    = () => setZoom(Math.round(map.getZoom()))
    const onPitch   = () => setPitch(Math.round(map.getPitch()))
    const onRotate  = () => setBearing(normBearing(map.getBearing()))
    map.on('zoom',   onZoom)
    map.on('pitch',  onPitch)
    map.on('rotate', onRotate)
    return () => {
      map.off('zoom',   onZoom)
      map.off('pitch',  onPitch)
      map.off('rotate', onRotate)
    }
  }, [map])

  const pitchLimit = () => getPitchLimit ? getPitchLimit() : 85

  const zoomIn      = () => map.easeTo({ zoom: map.getZoom() + 1, duration: 300 })
  const zoomOut     = () => map.easeTo({ zoom: map.getZoom() - 1, duration: 300 })
  const tiltUp      = () => map.easeTo({ pitch: Math.min(map.getPitch() + 10, pitchLimit()), duration: 300 })
  const tiltDown    = () => map.easeTo({ pitch: Math.max(map.getPitch() - 10, 0), duration: 300 })
  const rotateLeft  = () => { const b = map.getBearing(); map.easeTo({ bearing: Math.round(b / 30) * 30 - 30, duration: 300 }) }
  const rotateRight = () => { const b = map.getBearing(); map.easeTo({ bearing: Math.round(b / 30) * 30 + 30, duration: 300 }) }

  return (
    <div className='map-ctrl-card'>

      {/* ── Zoom ── */}
      <button className='map-ctrl-btn map-ctrl-btn--lg' onClick={zoomIn}>+</button>
      <div className='map-ctrl-value map-ctrl-value--lg'>{zoom}</div>
      <div className='map-ctrl-label'>ZOOM</div>
      <button className='map-ctrl-btn map-ctrl-btn--lg' onClick={zoomOut}>−</button>

      <div className='map-ctrl-sep' />

      {/* ── Compass ── rotates with map bearing; tap to reset North ── */}
      <svg
        className='map-ctrl-compass'
        width='22' height='22' viewBox='0 0 22 22'
        style={{ transform: `rotate(${bearing}deg)`, cursor: 'pointer' }}
        onClick={() => map.easeTo({ bearing: 0, duration: 300 })}
        title='Reset North'
      >
        <polygon points='11,2 7,18 11,14 15,18' fill='#589500' />
        <polygon points='11,20 7,4  11,8  15,4'  fill='#555' />
      </svg>

      <div className='map-ctrl-sep' />

      {/* ── Tilt + Rotate ── */}
      <div className='map-ctrl-tr-row'>

        <div className='map-ctrl-col'>
          <button className='map-ctrl-btn map-ctrl-btn--sm' onClick={tiltUp}>
            <svg width='13' height='9' viewBox='0 0 13 9'>
              <polyline points='1,8 6.5,1 12,8' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>
          </button>
          <div className='map-ctrl-value map-ctrl-value--sm'>{pitch}°</div>
          <button className='map-ctrl-btn map-ctrl-btn--sm' onClick={tiltDown}>
            <svg width='13' height='9' viewBox='0 0 13 9'>
              <polyline points='1,1 6.5,8 12,1' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>
          </button>
          <div className='map-ctrl-label'>TILT</div>
        </div>

        <div className='map-ctrl-divider-v' />

        <div className='map-ctrl-col'>
          <div className='map-ctrl-rotate-row'>
            <button className='map-ctrl-btn' onClick={rotateLeft}>
              <svg width='16' height='16' viewBox='0 0 20 20' fill='none' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round'>
                <path d='M4.5 10a5.5 5.5 0 1 0 5.5-5.5'/>
                <polyline points='6,2 4,6 8,6' fill='currentColor' stroke='none'/>
              </svg>
            </button>
            <button className='map-ctrl-btn' onClick={rotateRight}>
              <svg width='16' height='16' viewBox='0 0 20 20' fill='none' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round'>
                <path d='M15.5 10a5.5 5.5 0 1 1-5.5-5.5'/>
                <polyline points='14,2 16,6 12,6' fill='currentColor' stroke='none'/>
              </svg>
            </button>
          </div>
          <div className='map-ctrl-value map-ctrl-value--sm'>{bearing}°</div>
          <div className='map-ctrl-label'>ROTATE</div>
        </div>

      </div>

      <div className='map-ctrl-sep' />

      {/* ── Terrain exaggeration ── */}
      <div className='map-ctrl-terrain-row'>
        <svg width='14' height='11' viewBox='0 0 14 11' fill='none'>
          <polyline points='0,10 4,4 7,7 9,3 14,10' stroke='#888' strokeWidth='1.4' strokeLinejoin='round' fill='none'/>
        </svg>
        <input
          type='range'
          className='map-ctrl-terrain-input'
          min='0' max='3' step='0.5'
          value={exaggeration}
          onChange={e => setExaggeration(parseFloat(e.target.value))}
        />
        <span className='map-ctrl-terrain-val'>{exaggeration.toFixed(1)}×</span>
      </div>

    </div>
  )
}

export default MapControls3D
